(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    (() => {
  const WISHLIST_KEY = 'carybell_wishlist';

  function getWishlist() {
    try {
      const value = localStorage.getItem(WISHLIST_KEY);
      return value ? JSON.parse(value) : [];
    } catch {
      return [];
    }
  }

  function updateWishlistCount() {
    const countElement = document.querySelector(
      '[data-header-wishlist-count]'
    );

    if (!countElement) return;

    const wishlist = getWishlist();
    const count = wishlist.length;

    if (count > 0) {
      countElement.textContent = count;
      countElement.hidden = false;
    } else {
      countElement.textContent = '';
      countElement.hidden = true;
    }
  }

  updateWishlistCount();

  document.addEventListener('carybell:wishlist-change', updateWishlistCount);

  window.addEventListener('storage', (event) => {
    if (event.key === WISHLIST_KEY) {
      updateWishlistCount();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {

    if (window.CarybellProductActions) return;



    window.CarybellProductActions = true;



    const WISHLIST_KEY = 'carybell_wishlist';

    const COMPARE_KEY = 'carybell_compare';





    /* =========================================================

       STORAGE

       ========================================================= */



    function getItems(key) {

      try {

        const value = localStorage.getItem(key);

        return value ? JSON.parse(value) : [];

      } catch {

        return [];

      }

    }





    function saveItems(key, items) {

      try {

        localStorage.setItem(

          key,

          JSON.stringify(items)

        );

      } catch (error) {

        console.warn(

          '[Carybell] Unable to save product action.',

          error

        );

      }

    }





    /* =========================================================

       PRODUCT DATA

       ========================================================= */



    function getProduct(button) {

      return {

        id: String(button.dataset.productId || ''),

        handle: button.dataset.productHandle || '',

        title: button.dataset.productTitle || '',

        url: button.dataset.productUrl || ''

      };

    }





    /* =========================================================

       WISHLIST UI

       ========================================================= */



    function updateWishlistButtons() {

      const wishlist = getItems(WISHLIST_KEY);



      document

        .querySelectorAll('[data-wishlist-button]')

        .forEach((button) => {



          const productId =

            String(button.dataset.productId || '');



          /*

           * Ignore Shopify Theme Editor placeholder products.

           */

          if (!productId) {

            button.setAttribute(

              'aria-pressed',

              'false'

            );



            button.classList.remove(

              'is-active'

            );



            return;

          }



          const active = wishlist.some(

            (item) =>

              String(item.id) === productId

          );



          button.setAttribute(

            'aria-pressed',

            active ? 'true' : 'false'

          );



          button.classList.toggle(

            'is-active',

            active

          );

        });

    }





    /* =========================================================

       COMPARE UI

       ========================================================= */



    function updateCompareButtons() {

      const compare = getItems(COMPARE_KEY);



      document

        .querySelectorAll('[data-compare-button]')

        .forEach((button) => {



          const productId =

            String(button.dataset.productId || '');



          if (!productId) {

            button.setAttribute(

              'aria-pressed',

              'false'

            );



            button.classList.remove(

              'is-active'

            );



            return;

          }



          const active = compare.some(

            (item) =>

              String(item.id) === productId

          );



          button.setAttribute(

            'aria-pressed',

            active ? 'true' : 'false'

          );



          button.classList.toggle(

            'is-active',

            active

          );

        });

    }





    /* =========================================================

       WISHLIST

       ========================================================= */



    function toggleWishlist(button) {



      const product =

        getProduct(button);



      /*

       * Placeholder / Theme Editor product.

       */

      if (!product.id) {

        console.log(

          '[Carybell] Wishlist disabled for placeholder product.'

        );



        return;

      }



      let wishlist =

        getItems(WISHLIST_KEY);



      const index =

        wishlist.findIndex(

          (item) =>

            String(item.id) ===

            String(product.id)

        );





      if (index === -1) {



        wishlist.push(product);



      } else {



        wishlist.splice(

          index,

          1

        );

      }





      saveItems(

        WISHLIST_KEY,

        wishlist

      );



      updateWishlistButtons();





      document.dispatchEvent(

        new CustomEvent(

          'carybell:wishlist-change',

          {

            detail: {

              product,

              wishlist

            }

          }

        )

      );

    }





    /* =========================================================

       COMPARE

       ========================================================= */



    function toggleCompare(button) {



      const product =

        getProduct(button);



      if (!product.id) {

        console.log(

          '[Carybell] Compare disabled for placeholder product.'

        );



        return;

      }



      let compare =

        getItems(COMPARE_KEY);



      const index =

        compare.findIndex(

          (item) =>

            String(item.id) ===

            String(product.id)

        );





      /*

       * Remove

       */

      if (index !== -1) {



        compare.splice(

          index,

          1

        );



      }





      /*

       * Add

       */

      else {



        if (compare.length >= 4) {



          alert(

            'You can compare up to 4 products.'

          );



          return;

        }



        compare.push(product);

      }





      saveItems(

        COMPARE_KEY,

        compare

      );



      updateCompareButtons();





      document.dispatchEvent(

        new CustomEvent(

          'carybell:compare-change',

          {

            detail: {

              product,

              compare

            }

          }

        )

      );

    }





    /* =========================================================

       QUICK VIEW

       ========================================================= */



    async function openQuickView(button) {
      const card = button.closest('product-card');

      if (!card) return;

      await customElements.whenDefined('quick-add-component');

      const quickAdd = card.querySelector('quick-add-component');

      if (!quickAdd || typeof quickAdd.handleClick !== 'function') {
        console.error('[Carybell] Horizon quick-add-component is not ready.');
        return;
      }

      try {
        await quickAdd.handleClick(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }));
      } catch (error) {
        console.error('[Carybell] Quick View failed.', error);
      }
    }

    /* =========================================================

       GLOBAL CLICK HANDLER

       ========================================================= */



    document.addEventListener(

      'click',

      (event) => {



        const target =

          event.target;



        if (!(target instanceof Element)) {

          return;

        }





        /* ---------------------------------

           WISHLIST

           --------------------------------- */



        const wishlistButton =

          target.closest(

            '[data-wishlist-button]'

          );



        if (wishlistButton) {



          event.preventDefault();

          event.stopPropagation();

          event.stopImmediatePropagation();



          toggleWishlist(

            wishlistButton

          );



          return;

        }





        /* ---------------------------------

           COMPARE

           --------------------------------- */



        const compareButton =

          target.closest(

            '[data-compare-button]'

          );



        if (compareButton) {



          event.preventDefault();

          event.stopPropagation();

          event.stopImmediatePropagation();



          toggleCompare(

            compareButton

          );



          return;

        }





        /* ---------------------------------

           QUICK VIEW

           --------------------------------- */



        const quickViewButton =

          target.closest(

            '[data-quick-view-button]'

          );



        if (quickViewButton) {



          event.preventDefault();

          event.stopPropagation();

          event.stopImmediatePropagation();



          openQuickView(

            quickViewButton

          );



          return;

        }



      },

      true

    );





    /* =========================================================

       INITIAL STATE

       ========================================================= */



    function initialize() {



      updateWishlistButtons();



      updateCompareButtons();



      console.log(

        '[Carybell] Product actions initialized'

      );

    }





    if (

      document.readyState ===

      'loading'

    ) {



      document.addEventListener(

        'DOMContentLoaded',

        initialize,

        {

          once: true

        }

      );



    } else {



      initialize();



    }





    /* =========================================================

       DYNAMIC PRODUCT GRID SUPPORT

       ========================================================= */



    const observer =

      new MutationObserver(

        () => {



          updateWishlistButtons();



          updateCompareButtons();



        }

      );





    observer.observe(

      document.body,

      {

        childList: true,

        subtree: true

      }

    );



  })();
  } catch(e) { console.error(e); }
})();

})();
